import { useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom'
import { MyContext } from '../../Context/MyProvider';
import PageLoader from '../PageLoader';
import { useTranslation } from 'react-i18next';

const Pages = () => {
    const { t } = useTranslation();
    const { pagList, loading } = useContext(MyContext);
    const navigate = useNavigate();

    const Params = useParams();
    const Title = Params.title?.replaceAll('-', ' ');

    window.scrollTo(0, 0);

    if (loading) {
        return (
            <div className="py-5 min-h-[400px] flex items-center justify-center">
                <PageLoader loading={true} />
            </div>
        );
    }

    const matchedPage = pagList?.find(item => item.title.toLowerCase() === Title.toLowerCase());

    return (
        <div className='py-5 min-h-[400px] flex items-center justify-center'>
            <div className='width-container w-full'>
                {matchedPage ? (
                    <div>
                        <h3 className='text-[28px] font-bold text-gray-900 mb-4 border-b pb-2'>{matchedPage.title}</h3>
                        <div className='p-[20px] text-gray-700 leading-relaxed' dangerouslySetInnerHTML={{ __html: matchedPage?.description }} />
                    </div>
                ) : (
                    <div className="text-center py-12 px-4 bg-white rounded-2xl shadow border border-gray-150 flex flex-col items-center max-w-lg mx-auto">
                        <div className="w-16 h-16 bg-red-50 text-red-500 rounded-full flex items-center justify-center mb-4">
                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" fill="currentColor"/>
                            </svg>
                        </div>
                        <h2 className="text-xl font-bold text-gray-900 mb-2">{t("Page Not Found")}</h2>
                        <p className="text-gray-500 mb-6">{t("The page you are looking for does not exist or has been moved.")}</p>
                        <button onClick={() => navigate("/")} className="bg-[--bg-color] text-white px-6 py-2.5 rounded-xl font-semibold hover:opacity-90 active:scale-95 duration-150 shadow-md">
                            {t("Go Home")}
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Pages